module.exports = __webpack_public_path__ + "static/media/max_pontuation_icon.35a85ca3.svg";